export default "__VITE_ASSET__86638ecc__"